/**
 * @copyright Chianyu Inc., 2018 and onwards
 * @author Shengyi Liu
 * @des  账号相关请求封装
 */
const Fetch = require('@/base/store/fetch')
const Constant = require('@/base/constants')

var baseurl = Constant.API_SERVER_URL + 'v1/'
var Account_BaseUrl = baseurl + 'account/'
var Account_AdminUrl = Account_BaseUrl + 'admin/'

/**
 * 登录
 * @param username 用户名
 * @param password 密码
 * @returns {Promise<any>|*|void}
 */
export function login (username, password) {
  return Fetch.post(Account_BaseUrl + 'login', {
    username: username,
    password: password
  })
}

/**
 * 获取session中用户名
 * @returns {*}
 */
export function getUsername () {
  return Fetch.get(Account_BaseUrl + 'getusername')
}

/**
 * 获取用户列表信息
 * @param userArray 用户列表
 * @returns {*}
 */
export function getaccounts (userArray) {
  return Fetch.postJson(Account_BaseUrl + 'getaccounts', userArray)
}

/**
 * 获取用户账号信息(不处理邮箱手机敏感信息，需要管理权限)
 * @param user 用户名、邮箱、手机号
 * @returns {*}
 */
export function getaccountinfo (user) {
  return Fetch.get(Account_BaseUrl + 'getaccountinfo2', {
    acctname: user
  })
}

/** admin 接口 start**/

/**
 * 取消注销他人账号（需管理员权限）
 * @param account 用户名
 * @param reason 原因
 * @returns {Promise<*>}
 */
export function cancelRemoveOtherAccount (account, reason) {
  return Fetch.post(Account_AdminUrl + 'cancelremoveotheraccount', {
    account: account,
    reason: reason,
  })
}

/**
 *封禁 解封 账号（需管理员权限）
 * @param account 用户名
 * @param freeze 是否冻结
 * @param reason 原因
 * @returns {Promise<*>}
 */
export function freezeAccount (account, freeze, reason) {
  return Fetch.post(Account_AdminUrl + 'freezeaccount', {
    account: account,
    freeze: freeze,
    reason: reason,
  })
}

/**
 * 注销自己的账号
 * @returns {Promise<*>}
 */
export function removeSelfAccount () {
  return Fetch.post(Account_AdminUrl + 'removeselfaccount')
}

/**
 * 获取用户云盘空间（需要账号管理权限）
 * @param user 用户名
 * @returns {Promise<*>}
 */
export function getDiskSpaceInfo (user) {
  return Fetch.get(Account_AdminUrl + 'getdiskspaceinfo', {
    user: user
  })
}

/**
 * 设置用户云盘空间（需要账号管理权限
 * @param user 用户名
 * @param quota 云盘空间（单位字节）
 * @returns {*}
 */
export function setDiskSpaceInfo (user, quota) {
  return Fetch.post(Account_AdminUrl + 'setdiskspaceinfo', {
    user: user,
    quota: quota
  })
}

/**
 *  获取在线用户信息
 * @param startTime
 * @param endTime
 * @param offset
 * @param limit
 * @returns {*}
 */
export function getOnlineUsers (startTime, endTime, offset = 0, limit = 20) {
  return Fetch.get(Account_AdminUrl + 'getonlineusers', {
    startTime: startTime,
    endTime: endTime,
    offset: offset,
    limit: limit
  })
}

/**
 * useragent搜索在线用户
 * @param cond
 * @param startTime
 * @param endTime
 * @param offset
 * @param limit
 * @returns {*}
 */
export function searchOnlineUsers (cond, startTime, endTime, offset = 0, limit = 20) {
  return Fetch.get(Account_AdminUrl + 'searchonlineusers', {
    cond: cond,
    startTime: startTime,
    endTime: endTime,
    offset: offset,
    limit: limit
  })
}

/**
 * 获取某个用户所有登录信息
 * @param user
 * @returns {*}
 */
export function getUserAllUsers (user) {
  return Fetch.get(Account_AdminUrl + 'getuserallusers', {
    user: user
  })
}

/** admin 接口 start**/



// WEBPACK FOOTER //
// ./src/base/store/accountfetch.js